import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap"; 

function MakePayment(){

    const [accountNumber, setAccountNumber] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false);
     const [isLoading, setIsLoading] = useState(false); // Loading state for API
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const token = localStorage.getItem('token');
    const navigate = useNavigate(); // Initialize navigate
    const location = useLocation(); 
    const { amount, payment_icon, payment_type, paymentMethodid, paymentMethodName, promotion } = location.state || {}; 
    const username = localStorage.getItem('username');
    const [paymentSystems, setPaymentSystem] = useState([]);

    console.log( `paymentType: ${ payment_type}`);
    useEffect(() => {
        if (paymentMethodName) {
          const fetchPaymentMethodDetails = async () => {
            try {
              const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-wallet-number?name=${paymentMethodName}&account_type=${payment_type}&amount=${amount}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  'Origin': window.location.origin,
                },
              });
              const data = await response.json();
    
              if (data) {
                setPaymentSystem(data[0]);
                console.log(data);
              }
            } catch (error) {
              console.error("Error fetching payment method details:", error);
            } finally {
              setIsLoading(false);
            }
          };
    
          fetchPaymentMethodDetails();
        }
      }, [paymentMethodName, token]);
   

    const handleSubmit = async () => {
        // Validate each field with specific error messages
        if (!accountNumber || accountNumber.length !== 11 || !/^\d{11}$/.test(accountNumber)) {
          setModalMessage("Please provide a valid 11-digit account number.");
          setShowModal(true);
          return;
        }
        
        if (!transactionId) {
          setModalMessage("Please provide your TRX ID. It should be valid.");
          setShowModal(true);
          return;
        }
      
        setSubmitLoading(true);
        const remoteId = localStorage.getItem("remote_id");
      
        const requestBody = {
          remote_id: remoteId,
          account_number: accountNumber,
          transaction_id: transactionId,
          amount: amount,
          payment_id: paymentSystems.id,
          promotion_id: promotion, 
        };
      
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/api/submit-deposit`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(requestBody),
          });
      
          if (!response.ok) {
            const errorData = await response.json();
            setModalMessage("Submission failed: " + errorData.message);
            setShowModal(true);
            return;
          }
      
          const data = await response.json();
      
          if (data) {
            setModalMessage("Submission successful!");
      
            navigate("/payment-request", {
              state: {
                amount: amount,
                payment_icon: payment_icon,
              },
            });
          } else {
            setModalMessage(data.message);
            setShowModal(true); // Show modal with the error message
          }
        } catch (error) {
          setModalMessage("An error occurred. Please try again.");
          setShowModal(true); // Show modal on error
        } finally {
          setSubmitLoading(false);
        }
      };
      
    return(
    <div className={`make-payment ${paymentMethodName?.toLowerCase()}`}>
        <div className="payment-method-icon">
        <img className="payment-icon" src={payment_icon? `${process.env.REACT_APP_API_URL}/storage/${payment_icon}` : `${process.env.REACT_APP_API_URL}/default-icon.png`}  />
        
        <div className="payment-account">
            <span className="payment-account-name">{paymentMethodName}</span>
            <span className="payment-account-name">{amount}.00</span>
            <span className="payment-account-number">{paymentSystems.account_number}
            <button      
            onClick={() => {
                const accountNumber = paymentSystems;
                if (accountNumber) {
                  navigator.clipboard.writeText(accountNumber.account_number);
                  alert(`Account number copied: ${accountNumber.account_number}`);
                } else {
                  alert("No account number to copy!");
                }
              }}
                            style={{
                              background: "transparent",
                              padding: "0px 5px",
                              
                              cursor: "pointer",
                            }}
                          >
                            <img style={{width: "15px"}} className="copy-icon" src="./icons/copy.svg" alt="Copy" />
                          </button>
            </span>
            
                            
        </div>
        
        </div>
        <div className="payment-form">
            <input type="text"  value={accountNumber}
                            onChange={(e) =>
                              setAccountNumber(e.target.value)
                            } name="accountNumber" className="form-control" placeholder="Enter Sender Account Number" />
            <input type="text" 
            value={transactionId}
            onChange={(e) =>
              setTransactionId(e.target.value)
            }
            name="transactionId" className="form-control" placeholder="Enter TRX ID" />
            <input type="file" className="form-control" placeholder="" />
            <button onClick={handleSubmit} className={`btn pay ${paymentMethodName?.toLowerCase()}`}>Submit</button>
            
            
        </div>
            <div className="tips-info note">
                    <h5 className=""><i className="tips-icon"
                        style={{
                            maskImage:
                            'url("/assets/images/icon-set/icon-tips-type02.svg")',
                        }}
                        />
                        <span className="">
                        Dear, {username} Please follow the instructions below to make a payment.
                        </span>
                    </h5>
                    </div>
                    <div className="tips-info note">
                    <h5 className=""><i className="tips-icon"
                        style={{
                            maskImage:
                            'url("/assets/images/icon-set/icon-tips-type02.svg")',
                        }}
                        />
                        <span className="">
                       
  1. Select {payment_type === 'Agent' ? 'Cash Out' : 'Send Money'}.


                        </span>
                    </h5>
                    </div>
                    <div className="tips-info note">
                    <h5 className=""><i className="tips-icon"
                        style={{
                            maskImage:
                            'url("/assets/images/icon-set/icon-tips-type02.svg")',
                        }}
                        />
                        <span className="">
                         2. Copy The Account Number and paste it.
                           
                        </span>
                    </h5>
                    </div>
                    <div className="tips-info note">
                    <h5 className=""><i className="tips-icon"
                        style={{
                            maskImage:
                            'url("/assets/images/icon-set/icon-tips-type02.svg")',
                        }}
                        />
                        <span className="">
                            3. Enter the amount and send. 
                        </span>
                    </h5>
                    </div>
                    <div className="tips-info note">
                    <h5 className=""><i className="tips-icon"
                        style={{
                            maskImage:
                            'url("/assets/images/icon-set/icon-tips-type02.svg")',
                        }}
                        />
                        <span className="">
                       4. After sending the money, copy the TRX ID and take a Screenshot.
                        </span>
                    </h5>
                    </div>
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Error</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>{modalMessage}</p>
                            </Modal.Body>
                        </Modal>
    </div>
    );
}
export default MakePayment;